module.exports = __webpack_public_path__ + "media/images/menu/adrastea-18029e95a4f0a9c9580aa449030b3e17.jpg";